<template>
  <card @dragstart.native="dragStart" draggable dis-hover class="acts-group-item" :padding="8" @click.native="openAct">
    <div class="acts-group-item__header">
      <div class="acts-group-item__name ms-subhead">
        Акт №{{ act.number }}
      </div>
      <div class="acts-group-item__costs">
        <tag class="ms-costs" color="primary">
          {{ getFormattedCosts(act.costs, false, act.contract_with_vat) }}
        </tag>
      </div>
    </div>
    <div class="acts-group-item__roadmap-info">
      <div class="acts-group-item__stage-title ms-text">
        Этапы: {{ getRoadmapsNames() }}
      </div>
      <!-- <div class="acts-group-item__roadmap-dates ms-help">
        <span>Начало: {{ act.roadmap_start_date }}</span>
        <span>Окончание: {{ act.roadmap_end_date }}</span>
      </div> -->
    </div>
  </card>
</template>

<script>
import { getFormattedCosts, getActStatusColor } from '@/utils'

export default {
  props: ['act'],
  methods: {
    openAct () {
      this.$emit('open-act', {
        ...this.act,
        contract_id: this.act.contract_id
      })
    },
    dragStart (e) {
      e.dataTransfer.setData('act', JSON.stringify(this.act))
    },
    getRoadmapsNames () {
      return this.act.act_roadmaps
        .filter(r => r.roadmap_name)
        .map(r => r.roadmap_name)
        .join(', ')
    },
    getActStatusColor,
    getFormattedCosts
  }
}
</script>

<style lang="less">
.acts-group-item {
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  &__name {
    cursor: pointer;
  }

  &__roadmap-info {
    margin-top: 8px;
  }

  &__roadmap-dates {
    font-size: 11px;
    display: flex;
    flex-direction: column;

    span:first-child {
      margin-right: 8px;
    }
  }
}
</style>
